import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/cool-hooks/react-wordpress-hooks/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "page-revisions"
    }}>{`Page Revisions`}</h2>
    <h3 {...{
      "id": "usepagerevisions"
    }}>{`usePageRevisions`}</h3>
    <p><a parentName="p" {...{
        "href": "https://developer.wordpress.org/rest-api/reference/page-revisions/#list-page-revisions"
      }}>{`Available options`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const { data, loading, error } = usePageRevisions(
  /* parent id */,
  { /* WordPress REST API options */ }
);
`}</code></pre>
    <h3 {...{
      "id": "useretrievepagerevision"
    }}>{`useRetrievePageRevision`}</h3>
    <p><a parentName="p" {...{
        "href": "https://developer.wordpress.org/rest-api/reference/page-revisions/#retrieve-a-page-revision"
      }}>{`Available options`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const { data, loading, error } = useRetrievePageRevision(
  /* parent id */,
  /* page revision id */,
  /* type */,
  { /* WordPress REST API options */ }
);
`}</code></pre>
    <h3 {...{
      "id": "usedeletepagerevision"
    }}>{`useDeletePageRevision`}</h3>
    <p><a parentName="p" {...{
        "href": "https://developer.wordpress.org/rest-api/reference/page-revisions/#delete-a-page-revision"
      }}>{`Available options`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const { data, loading, error } = useDeletePageRevision(
  /* parent id */,
  /* page revision id */,
  { /* WordPress REST API options */ }
);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      